import * as React from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import UIFloatingAlertList from 'UIComponents/alert/UIFloatingAlertList';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import { H2 } from 'UIComponents/elements/headings';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import ErrorBoundary from 'flow-doctor-lib/components/common/ErrorBoundary';
import ObjectTypeLabel from 'flow-doctor-lib/components/common/ObjectTypeLabel';
import { DiagnosisPanelAlertStore } from 'flow-doctor-lib/constants/FloatingAlertStore';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DiagnosisPanelContainer = ({
  children,
  onClose,
  objectTypeId
}) => {
  const portalId = React.useMemo(() => PortalIdParser.get(), []);
  return /*#__PURE__*/_jsxs(UIModalPanel, {
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [objectTypeId && /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.enrolledTitle_jsx",
          elements: {
            ObjectTypeLabel
          },
          options: {
            objectTypeId,
            portalId,
            lowerCase: true
          }
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsxs(ErrorBoundary, {
      boundaryName: "ENROLLMENT_DIAGNOSIS_PANEL",
      renderError: () => /*#__PURE__*/_jsx(UIErrorMessage, {
        type: "badRequest",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.global.errorBoundary.title"
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.global.errorBoundary.description"
        })
      }),
      children: [/*#__PURE__*/_jsxs(UIDialogBody, {
        className: "p-x-0",
        children: [/*#__PURE__*/_jsx(UIFloatingAlertList, {
          use: "contextual",
          alertStore: DiagnosisPanelAlertStore
        }), children]
      }), /*#__PURE__*/_jsx(UIDialogFooter, {
        children: /*#__PURE__*/_jsx(UIFlex, {
          justify: "end",
          children: /*#__PURE__*/_jsx(UIButton, {
            use: "primary",
            onClick: onClose,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.done"
            })
          })
        })
      })]
    })]
  });
};
export default DiagnosisPanelContainer;